import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useLogout } from 'js/hooks/auth';
import { useNavigate } from 'js/hooks/navigate';
import { useAppSelector } from 'js/store/hooks';
import { prop } from 'ramda';
import { useSmartClosePopups } from '@core/js/components/common/PopupManager';

export const useLegacyLogoutHandler = () => {
    const logout = useLogout();
    const navigate = useNavigate();
    const rootPage = useAppSelector(prop('rootPage'));
    const closePopups = useSmartClosePopups();

    useEffect(() => {
        const invokeLogoutConfirmation = () => {
            logout({ isManual: true });
            closePopups('logout');
            navigate(rootPage);
        };

        dispatcher.listen('auth:action:logout', invokeLogoutConfirmation);

        return () => {
            dispatcher.removeListener('auth:action:logout', invokeLogoutConfirmation);
        };
    }, [closePopups, logout, navigate, rootPage]);
};
